const AGORA_APP_ID = "fa6a5896da504f0c89d7be86cc75bbf2"; // set your app id here

export default AGORA_APP_ID;
